/// <reference path="../../typings.d.ts" />
import { Injectable, Injector } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Observable ,  Observer } from 'rxjs';
import { Token } from '../models/token';
import { TokenHelper } from '../shared/token_helper';
import { Config } from '../config';
import { User } from '../models/user';
import { OAuthResponse } from '../models/oauth_response';

@Injectable()
export class AccountServiceMoc {
	th: TokenHelper;
	errConn: string;
	userKey: string = 'user';
	timeout: number = 1000; //1 sec
	retry: number = 3; //max retry
	public dateNowFunc: any;

	constructor(private config: Config, private http: Http) {
		this.th = new TokenHelper();
		this.errConn = 'There is an error when communicating with a server, please try again later.';
		this.dateNowFunc = () => { return new Date(); };
		if (!validateToken()) {
			this.setToken(new Token({
				accessToken: 'Code',
				scope: 'all',
				tokenType: 'Bearer',
				state: 'dashboard',
				expiresIn: 50000,
				expiresAt: this.th.getExpiresAt(50000),
				refreshToken: 'refresh',
			}));
		}
	}

	getUserProfileApi(): Observable<User> {
		let us = new User();

		us.firstName = 'ben';
		us.lastName = 'kolenovic';
		us.timeZone = 'tzone';
		us.email = 'ben@identakid.com';
		us.username = 'ben@identakid.com';
		us.userId = '12345';
		us.phoneNumber = '8009008888';


		return Observable.create((observer: Observer<User>) => {
			observer.next(us);
			observer.complete();
		});
	}

	getUser(): Observable<User> {
		if (localStorage.getItem(this.userKey) === null) {
			return null
		}
		return JSON.parse(localStorage.getItem(this.userKey));
	}

	setUser(user: User) {
		localStorage.setItem(this.userKey, JSON.stringify(user));
	}

	setToken(tk: Token) {
		this.th.setToken(this.config.tokenName, tk);
	}

	oauthLogin(ar: OAuthResponse) {
		ar.expiresAt = this.th.getExpiresAt(ar.expiresIn);
		this.th.setToken(this.config.tokenName, ar.getToken());
		return true;
	}

	getError(err: any): Error {
		var er: any;
		var msg = this.errConn;
		if (typeof (err.json) === 'function') {
			er = err.json();
			if (er.message != null && er.message != null && er.message != '') {
				msg = er.message;
			} else {
				console.log(err);
			}
			return new Error(msg);
		} else if (err instanceof Error) {
			return err;
		} else {
			console.log(err);
		}
	}

	getToken(): Token {
		return this.th.getToken(this.config.tokenName);
	}

	logout() {
		window.location.href = this.config.logoutUrl();
	}

	removeLocalStorage() {
		localStorage.removeItem(this.userKey);
		this.th.removeToken(this.config.tokenName);
	}

	logoutWithMsg(msg: string) {
		this.th.removeToken(this.config.tokenName);
		window.location.href = this.config.loginUrl() + 'msg=' + encodeURI(msg);
	}
}

export function validateToken(tokenName?: string, token?: Token) {
	var tname: string = tokenName || 'token';
	var t: Token;
	if (token) {
		t = token;
	} else {
		if (localStorage.getItem(tname) === null) {
			return false
		}
		let data = JSON.parse(localStorage.getItem(tname));
		t = new Token(data);
	}
	var tokenHelper = new TokenHelper();
	if (!t || tokenHelper.isTokenExpired(t)) {
		console.log('token is expired');
		return false
	} else {
		return true
	}
}
